import { Component, OnInit } from '@angular/core';
import { first, map } from 'rxjs/operators';
import { DbService } from 'src/app/core/services/db.service';

@Component({
  selector: 'app-show-terms',
  templateUrl: './show-terms.component.html',
  styleUrls: ['./show-terms.component.scss'],
})
export class ShowTermsComponent implements OnInit {
  service;
  constructor(private db: DbService) {}

  async ngOnInit(): Promise<void> {
    // 약관 데이터에 대해서 가져오기

    this.service = (await this.db.toDoc$(`admin/terms`)).service;
  }
}
